import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <FadeIn data-id="element-110">
          <h2 className="text-4xl md:text-5xl text-center mb-12" data-id="element-111">
            El problema real
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-112">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brown/5 text-lg md:text-xl leading-relaxed text-brown/90 space-y-6" data-id="element-113">
            <p data-id="element-114">
              Llevás meses escuchando que "ya va a pasar" o que tenés que
              "dejarlo llorar hasta que aprenda". Pero cada noche es una batalla
              nueva.
            </p>
            <p data-id="element-115">
              La falta de sueño no solo te deja ojeras; está afectando tu
              paciencia, tu relación de pareja y tu capacidad para disfrutar de
              tu hijo durante el día.
            </p>
            <p className="font-semibold text-brown text-xl md:text-2xl pt-4" data-id="element-116">
              El problema no es que tu bebé sea "mal dormidor". El problema es
              que su sistema nervioso está en alerta constante, bloqueando la
              melatonina que necesita para descansar profundo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}